function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Row, Container, Col, Table } from 'react-bootstrap';
import { Statistic, Divider, Skeleton, Form, Button, DatePicker, Space, Drawer, Alert } from 'antd';
import Common from "../components/includes/Common";
import CustomerTable from '../components/CustomerTable';
import { WalletFill, Cash, CreditCardFill, PersonFill, HouseFill } from 'react-bootstrap-icons';
import ValidationSheet from "../components/ValidationSheet";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Reports = function Reports() {
  var ref = useRef();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    customers = _useState2[0],
    setCustomers = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    monthCustomers = _useState4[0],
    setMonthCustomers = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDayDataLoading = _useState6[0],
    setIsDayDataLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isMonthDataLoading = _useState8[0],
    setIsMonthDataLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isDataDraweVisible = _useState0[0],
    setIsDataDrawerVisible = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    searchCustomers = _useState10[0],
    setSearchCustomers = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSearchDataLoading = _useState12[0],
    setIsSearchDataLoading = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    searchResponseMessage = _useState14[0],
    setSearchResponseMessage = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    agentsSales = _useState16[0],
    setAgentsSales = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isSheetDisplayed = _useState18[0],
    setIsSheetDisplayed = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedCustomer = _useState20[0],
    setSelectedCustomer = _useState20[1];
  var today = new Date();
  var date = today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
  var onSearchFinish = function onSearchFinish(values) {
    setSearchCustomers([]);
    setIsDataDrawerVisible(true);
    setIsSearchDataLoading(true);
    setSearchResponseMessage('');
    axios.post(Common.baseApiUrl + 'searchcustomersdata/' + Common.currentUser.id, {
      from: values.moment[0]._d,
      to: values.moment[1]._d
    }).then(function (response) {
      setIsSearchDataLoading(false);
      if (response.data.status == 200) {
        setSearchCustomers(response.data.customers);
      } else {
        setSearchResponseMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsSearchDataLoading(false);
      setSearchResponseMessage('Une erreur est survenue');
    });
  };
  var handleSheetDisplay = function handleSheetDisplay(c) {
    setSelectedCustomer(c);
    setIsSheetDisplayed(true);
  };
  useEffect(function () {
    setIsDayDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcurrentdaycustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsDayDataLoading(false);
      if (response.data.status == 200) setCustomers(response.data.customers);
    })["catch"](function (error) {
      setIsDayDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getcurrentmonthcustomers/' + Common.currentUser.id.toString()).then(function (response) {
      setIsMonthDataLoading(false);
      if (response.data.status == 200) setMonthCustomers(response.data.customers);
    })["catch"](function (error) {
      setIsMonthDataLoading(false);
    });
    axios.get(Common.baseApiUrl + 'getcustomersbyagent/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setAgentsSales(response.data.agentcustomers);
      }
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Drawer, {
      title: "Donn\xE9es",
      visible: isDataDraweVisible,
      onClose: function onClose() {
        setIsDataDrawerVisible(false);
      },
      width: "95%",
      destroyOnClose: false,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "cool-radius",
        children: [isSearchDataLoading && /*#__PURE__*/_jsx(Skeleton, {
          active: true
        }), searchResponseMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: searchResponseMessage
        }), /*#__PURE__*/_jsx("br", {}), searchCustomers.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              sm: 6,
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total clients",
                    value: searchCustomers.length.toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(PersonFill, {})
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Encaissement",
                    suffix: "GNF",
                    value: (searchCustomers.length * 200000).toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(Cash, {})
                  })
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 6,
              md: 6,
              sm: 6
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(CustomerTable, {
            customers: searchCustomers,
            sheetDisplayHandler: handleSheetDisplay,
            table: "stable"
          })]
        })]
      }), /*#__PURE__*/_jsx(Drawer, {
        title: "Donn\xE9es",
        visible: isSheetDisplayed,
        onClose: function onClose() {
          setIsSheetDisplayed(false);
        },
        width: "80%",
        destroyOnClose: false,
        children: /*#__PURE__*/_jsx(ValidationSheet, {
          ref: ref,
          customer: selectedCustomer
        })
      })]
    }), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsx(Form, {
              layout: "horizontal",
              onFinish: onSearchFinish,
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "moment",
                  rules: [{
                    required: true,
                    message: 'Veuillez choisir une période'
                  }],
                  children: /*#__PURE__*/_jsx(RangePicker, {
                    showTime: true
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  rules: [{
                    required: true,
                    message: 'send'
                  }],
                  children: /*#__PURE__*/_jsx(Button, {
                    htmlType: "submit",
                    type: "primary",
                    children: "Chercher"
                  })
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "RAPPORTS PAR CAISSIERE"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Table, {
              responsive: true,
              children: [/*#__PURE__*/_jsx("thead", {
                children: /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("th", {
                    children: "Pr\xE9nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Nom"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Login"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u CASH"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u TPE"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Re\xE7u OM"
                  }), /*#__PURE__*/_jsx("th", {
                    children: "Total Re\xE7u"
                  })]
                })
              }), /*#__PURE__*/_jsx("tbody", {
                children: agentsSales.map(function (a) {
                  return /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: a.firstname
                    }), /*#__PURE__*/_jsx("td", {
                      children: a.lastname
                    }), /*#__PURE__*/_jsx("td", {
                      children: a.mobile.slice(3)
                    }), /*#__PURE__*/_jsx("td", {
                      children: (a.customers.length * 200000).toLocaleString('Fr')
                    })]
                  }, a.id);
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "JOURNEE EN COURS"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), /*#__PURE__*/_jsx(Divider, {}), !isDayDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total clients",
                    value: customers.length.toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(PersonFill, {})
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Encaissements",
                    suffix: "GNF",
                    value: (customers.length * 200000).toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(Cash, {})
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 5,
          md: 5,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "MOIS EN COURS"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Ce mois ' + (today.getMonth() + 1) + '/' + today.getFullYear()
            }), /*#__PURE__*/_jsx(Divider, {}), !isMonthDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
              children: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total clients",
                    value: monthCustomers.length.toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(PersonFill, {})
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 12,
                  md: 12,
                  sm: 12,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Encaissements",
                    suffix: "GNF",
                    value: (monthCustomers.length * 200000).toLocaleString('Fr'),
                    prefix: /*#__PURE__*/_jsx(Cash, {})
                  })
                })]
              })
            }) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 10,
          md: 10,
          children: /*#__PURE__*/_jsxs("div", {
            className: "white-bg",
            children: [/*#__PURE__*/_jsx("h5", {
              children: "LISTE CLIENTS JOURNEE EN COURS"
            }), /*#__PURE__*/_jsx("span", {
              children: 'Aujourdhui ' + date
            }), !isDayDataLoading ? /*#__PURE__*/_jsx(_Fragment, {}) : /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })]
          })
        })
      }), /*#__PURE__*/_jsx("br", {})]
    })]
  });
};
export default Reports;